module.exports = __webpack_public_path__ + "img/0xC0FC9E41C84803fcE8A54Ca8bEcb73cEC3E9A533.f9dbe0c3.png";